import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import hlp from '../helpers';

const allowedConnections = {
  analytics: ['clusterlet'],
  sensor: [],
  clusterlet: ['analytics'],
  external_function: ['clusterlet'],
  analytics: ['external_function'],
};

export const validations = (handleType, nodeType) => (connection) => {
  const key = handleType === 'source' ? 'target' : 'source';
  const data = connection[key];
  const [toCheck] = data.split('-');
  if (allowedConnections[nodeType].includes(toCheck)) return true;
  return false;
};

export const AllowedConnections = (props) => {
  const { title = '', nodeTitle, type } = props;
  const connections = allowedConnections[type];
  return (
    <Grid container direction="column">
      <Grid item>
        <Typography style={{ wordWrap: 'break-word' }} variant="caption">
          {`Node: ${title}`}
        </Typography>
      </Grid>

      {nodeTitle && (
        <Grid item>
          <Typography style={{ wordWrap: 'break-word' }} variant="caption">
            {`Title: ${nodeTitle}`}
          </Typography>
        </Grid>
      )}

      {connections && connections.length ? <Typography variant="caption">Can be connected to</Typography> : null}

      {connections && connections.length
        ? connections.map((connection) => {
          return (
            <Grid item>
              <Typography variant="caption">{`${hlp.nodeKeysLabel[connection]}`}</Typography>
            </Grid>
          );
        })
        : null}
    </Grid>
  );
};
